export default [
    {
        path: '/:cid/digital-office',
        name: 'DigitalOfficeHome',
        component: () => import('@/views/DigitalOffice/DigitalOfficeHome.vue'),
        meta: { title: 'Văn phòng số', requiresAuth: true },
    },
    {
        path: '/:cid/office-apps',
        name: 'DigitalOfficeApps',
        component: () => import('@/views/DigitalOffice/DigitalOfficeApps.vue'),
        meta: { title: 'Văn phòng số', requiresAuth: true },
    },
    {
        path: '/:cid/employee-directory',
        name: 'EmployeeDirectory',
        component: () => import('@/views/DigitalOffice/EmployeeDirectory.vue'),
        meta: { title: 'Danh bạ nhân viên', requiresAuth: true },
    },
    {
        path: '/:cid/weekly-schedules',
        name: 'WeeklySchedules',
        component: () => import('@/views/DigitalOffice/WeeklySchedules.vue'),
        meta: { title: 'Lịch công tác tuần', requiresAuth: true },
    },
    { path: '/:cid/shared-documents', name: 'SharedDocuments', component: () => import('@/views/DigitalProcess/SharedDocuments.vue'), meta: { title: 'Tài liệu chia sẻ', requiresAuth: true } },
    { path: '/:cid/internal-library', name: 'SharedLibrary', component: () => import('@/views/DigitalProcess/SharedLibrary.vue'), meta: { title: 'Thư viện nội bộ', requiresAuth: true } },
    { path: '/:cid/internal-library/admin', name: 'SharedLibraryAdmin', component: () => import('@/views/DigitalProcess/SharedLibrary.vue'), meta: { title: 'Cập nhật thư viện nội bộ', requiresAuth: true } },
    { path: '/:cid/internal-library/catalog', name: 'SharedLibraryCatalog', component: () => import('@/views/DigitalProcess/SharedLibrary.vue'), meta: { title: 'Loại tài liệu nội bộ', requiresAuth: true } },
    { path: '/:cid/internal-library/folder/:folderId', name: 'SharedLibraryFolder', component: () => import('@/views/DigitalProcess/SharedLibrary.vue'), meta: { title: 'Thư viện nội bộ', requiresAuth: true } },
    { path: '/:cid/shared-library/:pathMatch(.*)*', redirect: to => `/${to.params.cid}/internal-library` },
    { path: '/:cid/company-news', name: 'CompanyNews', component: () => import('@/views/DigitalProcess/CompanyNews.vue'), meta: { title: 'Thông báo & Tin tức', requiresAuth: true } },
    { path: '/:cid/company-news/:id', name: 'CompanyNewsDetail', component: () => import('@/views/DigitalProcess/CompanyNewsDetail.vue'), meta: { title: 'Chi tiết tin tức', requiresAuth: true } },
    { path: '/:cid/digital-signatures', name: 'DigitalSignatureTemplates', component: () => import('@/views/DigitalOffice/DigitalSignatureTemplates.vue'), meta: { title: 'Kho chữ ký mẫu', requiresAuth: true } },
    { path: '/:cid/digital-signatures/sign', name: 'PdfSignatureEditor', component: () => import('@/views/DigitalOffice/PdfSignatureEditor.vue'), meta: { title: 'Ký hợp đồng PDF', requiresAuth: true } },
];
